@if(visible()){
<div class="jk-textarea-border">
  <app-jkfieldlabel [displayLabel]="displayLabel()" [label]="label()" [required]="required()"
    [emojiLabel]="emojiLabel()"></app-jkfieldlabel>
  <div></div>
  <textarea matImput class="jk-textarea-area" [rows]="rows()" [hidden]="!visible()" [disabled]="disabled()" [(value)]="value"
    [ngStyle]="{'min-height': minHeight + 'px', 'max-height': maxHeight + 'px', 'height': height() }"
    [readOnly]="readOnly" [placeholder]="placeholder" (change)="onValueChange($event)">
</textarea>

</div>

}